// extracted by mini-css-extract-plugin
export default {"subTitle":"index_subTitle__byc-C","instructions":"index_instructions__FaVad","instructions_line":"index_instructions_line__jPkK+"};